import React, { Fragment, useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import Table from './Table';
import ToggledRow from './ToggledRow';
import { useMediaQuery } from 'react-responsive/src';
import Title from './table/Title';
import TableCellText from './TableCellText';
import { Button } from 'react-bootstrap';
import ConfirmAlert from './ConfirmAlert';
import { useDispatch, useSelector } from 'react-redux';
import {
  incomingInstructorConnectionDemandList,
  incomingInstructorConnectionDemandUpdate,
} from '../app/store/action/organization';
import { Link } from '@material-ui/core';

export default function IncomingInstructorConnectionDemandList(props) {
  let { incomingInstructorConnectionDemandList, title, count, currentPage, pageParamName, onPageChange } = props;

  let [showCols, setShowCols] = useState({
    name: true,
    actions: false,
    more: true,
  });

  let [columns, setColumns] = useState([]);

  let allColumns = [
    {
      Header: 'نام و نام خانوادگی',
      accessor: 'name',
      colName: 'name',
      disableFilters: true,
      Cell: ({ row }) => (
        <TableCellText
          text={
            <a href={`/instructor/${row.original.instructor_profile_id}?demand=true&other_user=true`}>
              {row.original.user.first_name + ' ' + row.original.user.last_name}
            </a>
          }
        />
      ),
    },
    {
      Header: 'فعالیت',
      accessor: 'actions',
      colName: 'actions',
      disableFilters: true,
      Cell: ({ row }) => (
        <TableCellText
          text={
            <OkOrCancelRequestBtn
              id={row.original.id}
              nameOfUser={`${row.original.user.first_name} ${row.original.user.last_name}`}
            />
          }
        />
      ),
    },
    {
      Header: '',
      accessor: 'more',
      colName: 'more',
      disableFilters: true,
      Cell: ({ row }) => (
        <div {...row.getToggleRowExpandedProps()}>
          <TableCellText text={<span className={'font-weight-bold'}>بیشتر...</span>} />
        </div>
      ),
    },
  ];

  let isMDScreen = useMediaQuery({ query: '(min-width: 768px)' });
  let isXLScreen = useMediaQuery({ query: '(min-width: 1200px)' });

  // Toggled row to parents (used in mobile and tablet version)
  function toggledRow(row, visibleCols) {
    let fullRowValues = {
      ...row.original,
      name: `${row.original.user.first_name} ${row.original.user.last_name}`,
    };

    let items = {
      ...(!visibleCols.name && { name: 'نام و نام خانوادگی' }),
      ...(!visibleCols.actions && { actions: 'فعالیت' }),
    };
    return (
      <Fragment>
        <ToggledRow rowValues={fullRowValues} items={items} />
        {!visibleCols.actions && <OkOrCancelRequestBtn id={row.original.id} nameOfUser={fullRowValues.name} />}
      </Fragment>
    );
  }

  function fetchData() {}

  // toggle show property in toggleCols state
  function handleToggleCols(objShowCols, showCols, hideCols = []) {
    let newObjShowCols = { ...objShowCols };
    Object.keys(objShowCols).forEach(item => {
      if (showCols.includes(item)) newObjShowCols = { ...newObjShowCols, [item]: true };
      if (hideCols.includes(item)) newObjShowCols = { ...newObjShowCols, [item]: false };
    });

    return newObjShowCols;
  }

  useEffect(() => {
    let newToggleCols = { ...showCols };

    // toggle cols => more, group_name, phone_number
    let xsShowCols = ['more'];
    let xsHideCols = ['actions'];

    let mdShowCols = ['actions'];
    let mdHideCols = ['more'];

    let xlShowCols = ['actions'];
    let xlHideCols = ['more'];

    if (isXLScreen && isMDScreen) newToggleCols = handleToggleCols(newToggleCols, xlShowCols, xlHideCols);
    else if (!isXLScreen && isMDScreen) newToggleCols = handleToggleCols(newToggleCols, mdShowCols, mdHideCols);
    else newToggleCols = handleToggleCols(newToggleCols, xsShowCols, xsHideCols);

    setShowCols(newToggleCols);
    /* eslint-disable-next-line */
  }, [isMDScreen, isXLScreen]);

  useEffect(() => {
    let newColumns = allColumns.filter(item => showCols[item.colName]);

    setColumns(newColumns);
    /* eslint-disable-next-line */
  }, [showCols]);

  return (
    <Fragment>
      <Title value={title} />
      <Table
        data={incomingInstructorConnectionDemandList.data}
        /* eslint-disable-next-line */
        columns={useMemo(() => columns)}
        hasPagination={false}
        fetchData={fetchData}
        loading={incomingInstructorConnectionDemandList.isLoading}
        count={count}
        toggledRow={toggledRow}
        showToggledRow={!isXLScreen}
        toggledRowProps={showCols}
        currentPage={currentPage}
        onPageChange={onPageChange}
        pageParamName={pageParamName}
      />
    </Fragment>
  );
}

function OkOrCancelRequestBtn(props) {
  let { id, nameOfUser } = props;

  let [visibleOkConfirm, setVisibleOkConfirm] = useState(false);
  let [visibleCancelConfirm, setVisibleCancelConfirm] = useState(false);
  let [loading, setLoading] = useState(false);

  let detailOfIncomingInstructorConnectionDemand = useSelector(
    state => state.organization.incomingInstructorConnectionDemand
  );

  let dispatch = useDispatch();

  function handleConfirmClickOk() {
    dispatch(incomingInstructorConnectionDemandUpdate(id, { is_accept: true })).then(() => {
      dispatch(incomingInstructorConnectionDemandList());
      setVisibleOkConfirm(false);
    });
    setLoading(true);
  }

  let handleCancelClickOk = () => setVisibleOkConfirm(false);

  function handleConfirmClickCancel() {
    dispatch(incomingInstructorConnectionDemandUpdate(id, { is_accept: false })).then(() => {
      dispatch(incomingInstructorConnectionDemandList());
      setVisibleOkConfirm(false);
    });
    setLoading(true);
  }

  let handleCancelClickCancel = () => setVisibleCancelConfirm(false);

  useEffect(() => {
    let condition = !!detailOfIncomingInstructorConnectionDemand.data;
    if (condition) {
      setLoading(false);
      setVisibleCancelConfirm(false);
      setVisibleOkConfirm(false);
    }
  }, [detailOfIncomingInstructorConnectionDemand.data]);

  return (
    <Fragment>
      <Button variant={'outline-success'} onClick={() => setVisibleOkConfirm(true)}>
        <i className="fas fa-check" />
        تایید
      </Button>
      <Button variant={'outline-danger ml-2'} onClick={() => setVisibleCancelConfirm(true)}>
        <i className="fas fa-times" />
        رد
      </Button>
      <ConfirmAlert
        onConfirm={handleConfirmClickOk}
        visible={visibleOkConfirm}
        title={` تایید درخواست استاد شدن ${nameOfUser}`}
        onClose={handleCancelClickOk}
        body={'آیا مطمئن هستید؟'}
        confirmLoading={loading}
      />
      <ConfirmAlert
        onConfirm={handleConfirmClickCancel}
        visible={visibleCancelConfirm}
        title={` لغو درخواست استاد شدن ${nameOfUser}`}
        onClose={handleCancelClickCancel}
        body={'آیا مطمئن هستید؟'}
        confirmLoading={loading}
      />
    </Fragment>
  );
}

IncomingInstructorConnectionDemandList.propTypes = {
  incomingInstructorConnectionDemandList: PropTypes.shape({
    data: PropTypes.array,
    isLoading: PropTypes.bool,
  }).isRequired,
  count: PropTypes.number,
  currentPage: PropTypes.number,
  onPageChange: PropTypes.func,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  pageParamName: PropTypes.string,
  type: PropTypes.oneOf(['admin', 'courseCreator']),
};

OkOrCancelRequestBtn.propTypes = {
  id: PropTypes.number,
  nameOfUser: PropTypes.string,
};

const MEMBERSHIP_TYPES = {
  course_creator: 'دوره ساز',
  admin: 'مدیر',
  instructor: 'استاد',
};
